import { useEffect, useState } from 'react'

const Authorize = () => {
  const [boardId, setBoraId] = useState<string | null>()

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const boardId = urlParams.get('boardId')
    setBoraId(boardId)
  }, [])

  return (
    <div className="flex h-screen w-full justify-center items-center">
      <div className="flex flex-col gap-4">
        <img
          className="w-48"
          src="https://pi-cdn.atl-paas.net/celebration.svg"
          alt="Success!"
        />
        <div>
          <h1>Success!</h1>
          <p>Your TaskCtrl account was connected with Miro.</p>
        </div>
        <p>
          <a
            href={`https://miro.com/app/board/${boardId ?? ''}`}
            className="button  sticky bottom-0 button-primary"
          >
            Back to Miro
          </a>
        </p>
      </div>
    </div>
  )
}

export default Authorize
